import { DOC_FLOW_PHASE_WARNING_SCANNED_NOTIFICATION_SPLITTING } from '../DocFlow.constants'
import {
  isDocFlowWidgetStatusInProgress,
  isDocFlowWidgetStatusNotStarted,
} from '../DocFlow.utils.widgets'

import { DOC_FLOW_WIDGETS_SPLITTING_MAPPING_PERMANENT_NOTIFICATION_ID } from './DocFlowWidgets.constants'

export function isDocFlowUnvisitedWidget(processData, widgetType) {
  return (
    !processData || isDocFlowWidgetStatusNotStarted(processData[widgetType])
  )
}

export function isDocFlowWidgetDisabled(processData, widget) {
  return !isDocFlowWidgetStatusInProgress(processData?.[widget])
}

export function getDocFlowSplittingAndMappingWidgetPermanentNotifications(t) {
  return [
    {
      id: DOC_FLOW_WIDGETS_SPLITTING_MAPPING_PERMANENT_NOTIFICATION_ID,
      text: t(DOC_FLOW_PHASE_WARNING_SCANNED_NOTIFICATION_SPLITTING.text),
      type: DOC_FLOW_PHASE_WARNING_SCANNED_NOTIFICATION_SPLITTING.type,
    },
  ]
}
